import Question from './interfaces/Question';

export function isQuestionComplete(question: Question): boolean {
    return question.complete || Boolean(question.forcedComplete);
}
